import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Container } from "~/atoms/Container";
import { Feature } from "~/atoms/IndexPageFeature";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

export const Features: React.FC<{}> = () => {
  const { feature1, feature2, feature3, feature4 } = useStaticQuery<GatsbyTypes.featureImageQuery>(graphql`
    query featureImage {
      feature1: file(relativePath: { eq: "feature1.png" }) {
        childImageSharp {
          gatsbyImageData(width: 600, quality: 100, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      feature2: file(relativePath: { eq: "feature2.png" }) {
        childImageSharp {
          gatsbyImageData(width: 600, quality: 100, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      feature3: file(relativePath: { eq: "feature3.png" }) {
        childImageSharp {
          gatsbyImageData(width: 600, quality: 100, placeholder: NONE, layout: CONSTRAINED)
        }
      }
      feature4: file(relativePath: { eq: "feature4.png" }) {
        childImageSharp {
          gatsbyImageData(width: 600, quality: 100, placeholder: NONE, layout: CONSTRAINED)
        }
      }
    }
  `);

  return (
    <>
      <div id="whyChooseUs" className="anchor" />
      <section className="section">
        <Container>
          <div className="head">
            <p className="eyebrow">導入から定着まで、一貫して支援します</p>
            <h2 className="title">Refcomeが選ばれる理由</h2>
          </div>

          <div className="features">
            <Feature
              number="01"
              subTitle="大手からベンチャーまで1,000社以上の"
              title="採用支援実績"
              description="大企業やベンチャー企業、官公庁など、幅広い企業・組織を支援してきました。多様な支援で培ったノウハウをもとに、各社の課題に合わせたリファラル採用の仕組みづくりを支援します。"
              imageData={feature1?.childImageSharp?.gatsbyImageData}
            />
            <Feature
              number="02"
              subTitle="月30〜50時間の伴走支援"
              title="実行まで支えるサポート体制"
              description="担当者が施策の企画から実行、振り返りまで伴走します。導入時の説明会や社内広報コンテンツの作成など、社内への浸透と定着に向けた取り組みも支援します。"
              imageData={feature2?.childImageSharp?.gatsbyImageData}
              direction="ltr"
            />
            <Feature
              number="03"
              subTitle="成果報酬型にも対応"
              title="柔軟な料金体系"
              description="初期費用0円で始められる成果報酬型プランや、予算を立てやすい固定型プランなど、課題や状況に応じた料金体系をご用意しています。導入時の負担やリスクを抑えながら、無理のない形で取り組みを始められます。"
              imageData={feature3?.childImageSharp?.gatsbyImageData}
            />
            <Feature
              number="04"
              subTitle="リファラル採用に特化した"
              title="専用クラウドシステム"
              description="タレントプール機能を備えたクラウドツールで、社内浸透や候補者管理、効果測定を支援します。人事・社員・候補者の接点をつなぎ、紹介活動を運用しやすくします。"
              imageData={feature4?.childImageSharp?.gatsbyImageData}
              direction="ltr"
            />
          </div>
        </Container>
      </section>

      <style jsx>{`
        .anchor {
          display: block;
          height: 90px;
          margin-top: -90px;
          visibility: hidden;
        }

        .section {
          padding: 88px 24px 96px;
          background: ${colors.white};
        }
        .section :global(.container) {
          display: block;
          width: 100%;
          max-width: 1000px;
        }

        /* ---------- 見出し（Servicesと同じ型） ---------- */
        .head {
          text-align: center;
        }
        .eyebrow {
          margin: 0;
          color: ${colors.defaultText};
          font-size: 24px;
          font-weight: bold;
          line-height: 1.5;
        }
        .title {
          margin: 4px 0 0;
          color: ${colors.defaultText};
          font-size: 48px;
          font-weight: bold;
          line-height: 1.3;
          letter-spacing: 0.02em;
        }

        .features {
          margin-top: 44px;
        }

        /* ---------- タブレット ---------- */
        @media (${breakPoints.tablet}) {
          .section {
            padding: 64px 24px 72px;
          }
          .title {
            font-size: 40px;
          }
          .features {
            margin-top: 32px;
          }
        }

        /* ---------- スマホ ---------- */
        @media (${breakPoints.sp}) {
          .section {
            padding: 48px 16px 56px;
          }
          .eyebrow {
            font-size: 17px;
          }
          .title {
            font-size: 28px;
          }
          .features {
            margin-top: 24px;
          }
        }
      `}</style>
    </>
  );
};
